import { listenToParentSendMessage } from '@trimble-agentic-external-npm-local/agentic-platform-sdk-iframe-typescript';
import type { ExternalSendMessageContent } from '@trimble-agentic-internal-npm-local/agentic-chat-ui';

const onParentSendMessageError = (error: Error) => {
  console.error('Parent sendMessage failed', error);
};

/** Stable subscribe fn for chat-ui `externalSendMessageSource`. */
export const subscribeToParentSendMessage = (
  handler: (
    content: ExternalSendMessageContent,
    autoSend?: boolean
  ) => void | Promise<void>
): (() => void) =>
  listenToParentSendMessage(({ content, autoSend }) => {
    void Promise.resolve(handler(content, autoSend)).catch(error => {
      onParentSendMessageError(
        error instanceof Error ? error : new Error(String(error))
      );
    });
  }, onParentSendMessageError);
